import React from 'react';

import AddIcon from 'icons/add.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import RowBar from 'components/application/RowBar';
import SearchField from 'components/application/SearchField';
import Tooltip from 'components/application/Tooltip';

import { useCurrentActor } from 'components/contexts/CurrentActor';

export default function TeamsBar({
  isActionButtonVisible,
  onAddTeamClick,
  onSearchInputChange,
  onSearchReset,
  teams,
  teamsSearch,
}) {
  const {
    subscription: {
      attributes: { teamAllowance },
    },
  } = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'teams.TeamsBar',
  });

  const { t: i18nTTeams } = useTranslation('common', {
    keyPrefix: 'teams',
  });

  const teamsTotalCount = teams.loaded && teams.metaData.totalCount;

  const isTeamsLimitReached =
    teamAllowance !== null && teamsTotalCount >= teamAllowance;

  const isDisabled = !teams.loaded || isTeamsLimitReached;

  return (
    <RowBar
      actions={
        isActionButtonVisible && (
          <div className='tooltip-parent'>
            <OutlinedButton
              color='grey'
              disabled={isDisabled}
              onClick={onAddTeamClick}
              size='sm'
            >
              <AddIcon className='-tw-ml-2' height={24} width={24} />
              <span>{i18nTTeams('addNewTeam')}</span>
            </OutlinedButton>
            {isDisabled && (
              <Tooltip
                placement='top'
                tooltip={
                  teams.loaded ?
                    isTeamsLimitReached &&
                    i18nT('disabledTooltips.limitReached')
                  : i18nT('disabledTooltips.notLoaded')
                }
                trigger='hover'
              />
            )}
          </div>
        )
      }
      additionalClasses='tw-p-4 tw-border-b-0'
      content={
        <SearchField
          additionalClasses='search-field__lg'
          name='teamsSearch'
          onChange={onSearchInputChange}
          onReset={onSearchReset}
          placeholder={i18nTTeams('searchTeams')}
          value={teamsSearch}
        />
      }
    />
  );
}

TeamsBar.propTypes = {
  teams: PropTypes.shape({
    loaded: PropTypes.bool.isRequired,
    collection: PropTypes.array.isRequired,
    metaData: PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  teamsSearch: PropTypes.string.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  onSearchReset: PropTypes.func.isRequired,
  onAddTeamClick: PropTypes.func,
  isActionButtonVisible: PropTypes.bool.isRequired,
};
